import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
// import QrReader from 'react-qr-scanner'
import QrReader from 'react-qr-reader'

const styles = theme => ({
  disabled: {
    display: 'none'
  },
  enabled: {
    display: 'inherit'
  },
  placeholder: {
    display: 'block'
  }
})
const style = {
  LOADED: {
    width: '100%'
  },
  UNLOADED: {
    width: '100%'
  }
}
export const Webcam = ({ enabled, loaded, webcamLoaded, front, handleScan, handleError, classes }) => {

  function _handleScan(data) {
    if (data) {
      return handleScan(data);
    }
  }
  return (
    <div style={loaded ? style.LOADED : style.UNLOADED}>
      <QrReader
        maxImageSize={10}
        delay={300}
        onError={handleError}
        onScan={_handleScan}
        onLoad={webcamLoaded}
        className={
          enabled ? classes.enabled : classes.disabled
        }
        style={{ width: '100%' }}
        facingMode={front ? "user" : "environment"}
        showViewFinder={enabled}
      />
    </div>
  )
}
Webcam.propTypes = {
  enabled: PropTypes.bool.isRequired,
  loaded: PropTypes.bool.isRequired,
  webcamLoaded: PropTypes.func.isRequired,
  handleScan: PropTypes.func.isRequired,
  handleError: PropTypes.func.isRequired,
  classes: PropTypes.object,
  front: PropTypes.bool.isRequired
}

export default withStyles(styles)(Webcam);


// WEBPACK FOOTER //
// ./src/components/webcam.js